// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lesson1_wrapper_DaJlX"};